import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const GlobalSelectField = ({ options, disabled, variant, onChange, height = '100%', fontSize = '1rem' }) => {
  const [feildLabel, setFeildLabel] = useState('');
  const [itemData, setItemData] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [feildName, setFeildName] = useState('');
  const [err, setErr] = useState(false);
  const [helperText, setHelperText] = useState('');
  const [itemId, setId] = useState('');
  const [itemValue, setValue] = useState('');
  const [style, setStyle] = useState({});
  const [selectField, setSelectField] = useState(null);

  useEffect(() => {
    if (options) {
      if (options.label) {
        setFeildLabel(options.label);
      }
      if (options.data) {
        setItemData(options.data);
      }
      if (options.keys) {
        const { id, value, ...other } = options.keys;
        setId(id);
        setValue(value);
      }
      if (options.name) {
        setFeildName(options.name);
      }
      if (options.sx) {
        setStyle(options.sx);
      }
      if (options.formik && options.name) {
        setInputValue(options.formik.values[options.name]);
        setHelperText(options.formik.touched[options.name] && options.formik.errors[options.name]);
        // setHelperText(options.formik.touched[options.name] && options.formik.errors[options.name]);
        setErr(options.formik.touched[options.name] && Boolean(options.formik.errors[options.name]));
        // setErr(options.formik.touched[options.name] && Boolean(options.formik.errors[options.name]));
      }
      if (options.setFieldName) {
        setSelectField(options.setFieldName);
      }
    }
  }, [options]);

  const handleChange = (e) => {
    const selectedValue = e.target.value;
    setInputValue(e.target.value);
    if (options.formik && options.name) {
      options.formik.setFieldValue(feildName, e.target.value);
      options.formik.handleChange(e);
    }
    if (onChange) {
      onChange(selectedValue); // pass selected value
    }
  };

  return (
    <FormControl
      sx={{
        ...style,
        // minWidth: 160,
        // flex: 1,
        '& .MuiInputBase-root': {
          height: height, // Reduce input height
          fontSize: fontSize, // Reduce text size inside select box
        },
        '& .MuiInputLabel-root': {
          fontSize: fontSize,
        },
        '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
          marginTop: height != '100%' ? '-7px' : '0px',
        },
      }}
      size="medium"
      error={err}
      disabled={disabled}
    >
      <InputLabel id="demo-simple-select-label">{feildLabel}</InputLabel>
      <Select
        name={feildName}
        labelId="demo-simple-select-label"
        label={feildLabel}
        value={inputValue}
        onChange={handleChange}
        variant={variant}
        sx={{
          fontSize: fontSize, // Optional: reinforce font size here
        }}
      >
        {itemData?.map((item) => (
          <MenuItem
            key={item[itemId]}
            value={selectField ? item[selectField] : item[itemId]}
            sx={{
              fontSize: fontSize, // Menu item font size
            }}
          >
            {item[itemValue]}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText id="course-helper" sx={{ fontSize: fontSize }}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
};

export default GlobalSelectField;
